export const reportType = [
  {
    name: "Reporte Top 10",
    id: "TOP10",
  },
  {
    name: "Reporte General",
    id: "ALL",
  },
];

export const detailLevel = [
  {
    name: "Empresa",
    id: "company",
  },
  {
    name: "Laboratorio",
    id: "manufacturer",
  },
  {
    name: "Categoria",
    id: "category",
  },
  {
    name: "Product",
    id: "product",
  },
  {
    name: "Presentación",
    id: "presentation",
  },
];

export const data = [
  {
    name: "Unidades",
    id: "unidades",
  },
  {
    name: "Valores",
    id: "valores",
  },
];

export const terms = [
  {
    name: "I TRIMESTRE",
    id: "I",
  },
  {
    name: "II TRIMESTRE",
    id: "II",
  },
  {
    name: "III TRIMESTRE",
    id: "III",
  },
  {
    name: "IV TRIMESTRE",
    id: "IV",
  },
  {
    name: "ACUMULADO al II TRIMESTRE",
    id: "acumuladoII",
  },
  {
    name: "ACUMULADO al III TRIMESTRE",
    id: "acumuladoIII",
  },
  {
    name: "ACUMULADO al IV TRIMESTRE",
    id: "acumuladoIV",
  },
  {
    name: "TODO EL AÑO",
    id: "anio",
  },
];
